import { defineAsyncComponent } from 'vue';
import { GlSprintf, GlLink } from '@gitlab/ui';
import { helpPagePath } from '~/helpers/help_page_helper';
import { s__ } from '~/locale';
import reportsMixin from 'ee/vue_shared/security_reports/mixins/reports_mixin';
import CEWidgetOptions from '~/vue_merge_request_widget/mr_widget_options.vue';
import MrWidgetAlertMessage from '~/vue_merge_request_widget/components/mr_widget_alert_message.vue';
import MrWidgetPipelineContainer from '~/vue_merge_request_widget/components/mr_widget_pipeline_container.vue';
import MrWidgetApprovals from 'ee_else_ce/vue_merge_request_widget/components/approvals/approvals.vue';
import MrWidgetAutoMergeEnabled from '~/vue_merge_request_widget/components/states/mr_widget_auto_merge_enabled.vue';
import MergeChecks from '~/vue_merge_request_widget/components/merge_checks.vue';
import ReadyToMerge from '~/vue_merge_request_widget/components/merge_widget.vue';
import Loading from '~/vue_merge_request_widget/components/loading.vue';
import MrWidgetGeoSecondaryNode from './components/states/mr_widget_secondary_geo_node.vue';
import MrWidgetSecurityPolicyPipelineNote from './components/mr_widget_security_policy_pipeline_note.vue';
import { SECURITY_POLICY_PIPELINE_CHECK, BLOCKING_STATUSES } from './components/checks/constants';
import WidgetContainer from './components/widget/app.vue';
export default {
    name: 'MRWidgetRootEE',
    components: {
        GlSprintf,
        GlLink,
        WidgetContainer,
        MrWidgetGeoSecondaryNode,
        MrWidgetAlertMessage,
        MrWidgetPipelineContainer,
        MrWidgetApprovals,
        MrWidgetAutoMergeEnabled,
        MrWidgetSecurityPolicyPipelineNote,
        Loading,
        MergeChecks,
        ReadyToMerge,
        AgentSessionsWidget: defineAsyncComponent(()=>import('ee/vue_merge_request_widget/widgets/agent_sessions/index.vue')),
        MrRiskAssessmentWidget: defineAsyncComponent(()=>import('ee/vue_merge_request_widget/widgets/risk_assessment/app.vue')),
        BlockingMergeRequestsReport: defineAsyncComponent(()=>import('./components/blocking_merge_requests/blocking_merge_requests_report.vue'))
    },
    manageStorageDocsMsg: s__('mrWidget|To continue, %{docLinkStart}manage your storage usage%{docLinkEnd}.'),
    manageStorageDocsLink: helpPagePath('user/storage_usage_quotas'),
    extends: CEWidgetOptions,
    mixins: [
        reportsMixin
    ],
    computed: {
        mergeCheck () {
            return (this.mergeChecksState?.mergeabilityChecks || []).find((c)=>c.identifier === SECURITY_POLICY_PIPELINE_CHECK) || null;
        },
        shouldShowSecurityPolicyPipelineNote () {
            const isBlocking = BLOCKING_STATUSES.includes(this.mergeCheck?.status);
            return Boolean(this.mr?.isPipelinePassing && isBlocking && this.mr?.securityPoliciesPath);
        },
        shouldRenderRiskAssessment () {
            return Boolean(this.mr?.iid && this.mr?.riskAssessmentAvailable);
        }
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties -- overrides parent CEWidgetOptions method, called by parent component lifecycle
        getServiceEndpoints (store) {
            const base = CEWidgetOptions.methods.getServiceEndpoints(store);
            return {
                ...base,
                apiApprovalSettingsPath: store.apiApprovalSettingsPath
            };
        }
    }
};
